window.addEventListener("pageshow", event => {
    function tryRemoveSpinner(retry) {
        const checkoutBtn = document.querySelector('.ootdy_checkout_button');
        const spinner = checkoutBtn && checkoutBtn.querySelector('.o2-btn-spinner');
        if (spinner) {
            spinner.remove();
        } else if (retry > 0) {
            setTimeout(() => tryRemoveSpinner(retry - 1), 100);
        }
    }
    tryRemoveSpinner(20);       
});


(function() {
    const getNonDiscountTotal = function() {
        let nonDiscountTotal = 0;
        // const cartContainer = document.querySelector('.t4s-mini_cart__items');
        // if (!cartContainer) {
        //     return 0;
        // }
        // const cartItems = cartContainer.querySelectorAll('.t4s-mini_cart__item');
        // cartItems.forEach(item => {
        //     try {
        //         const itemDataRaw = item.getAttribute('item-data');
        //         if (!itemDataRaw) return;

        //         const itemData = JSON.parse(itemDataRaw);
        //         const price = itemData.price || 0; 
        //         const tag_list = itemData.tags || []
        //         if (tag_list.includes("Lab Grown Diamond") || tag_list.includes("10K Yellow Gold")) {
        //             const quantityInput = item.querySelector('.t4s-quantity-input');
        //             const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 0;
        //             if (!isNaN(quantity)) {
        //                 nonDiscountTotal += price * quantity;
        //             }
        //         }
        //     } catch (error) {
        //         console.error("Failed to parse cart product data:", error);
        //     }
        // });
        return nonDiscountTotal / 100;
    }
    const updateNewPriceBlock = function() {
        let finalPrice = 0, discountPrice = 0, currency = '';
        const t4sTotalPriceBlock = document.querySelector('div.t4s-cart__totalPrice');
        const t4sDiscountPriceBlock = document.querySelector('div.t4s-cart__discountPrice');
        if (t4sTotalPriceBlock != null) {
            let priceText = t4sTotalPriceBlock.textContent;
            currency = t4sTotalPriceBlock.textContent[0];
            if (currency == '$' || currency == '£') {
                priceText = priceText.replace(',', '');
            } else if (currency == '€') {
                priceText = priceText.replace('.', '').replace(',', '.');
            }
            finalPrice = parseFloat(priceText.slice(1));
            console.log(`total price = ${currency}${finalPrice} currency = ${currency}`);
        } else {
            console.log("Failed to find total price block !!!");
            return;
        }
        if (t4sDiscountPriceBlock != null) {
            let priceText = t4sDiscountPriceBlock.textContent;
            if (currency == '$' || currency == '£') {
                priceText = priceText.replace(',', '');
            } else if (currency == '€') {
                priceText = priceText.replace('.', '').replace(',', '.');
            }
            discountPrice = parseFloat(priceText.slice(1));
            console.log(`discount price = ${currency}${discountPrice}`);
        }
        let discountRate = 0;
        let subtotalPrice = finalPrice + discountPrice;

        const subtotalPriceRow = document.querySelector('div.o2-mcart-subtotal-price-row');
        const subtotalPriceField = subtotalPriceRow.querySelector('div.o2-mcart-price-text');
        let subtotalPriceText = `${currency}${subtotalPrice}`;
        if (currency == '€') { subtotalPriceText.replace('.', ','); }
        subtotalPriceField.textContent = subtotalPriceText;

        const discountPriceRow = document.querySelector('div.o2-mcart-discount-price-row');
        const discountPriceField = discountPriceRow.querySelector('div.o2-mcart-price-text')
        let discountPriceText = `${currency}${discountPrice}`;
        if (currency == '€') { discountPriceText = discountPriceText.replace('.', ','); }
        discountPriceField.textContent = "-" + discountPriceText;

        const finalPriceRow = document.querySelector('div.o2-mcart-total-price-row');
        const finalPriceField = finalPriceRow.querySelector('div.o2-mcart-price-text');
        let finalPriceText = `${currency}${finalPrice}`;
        if (currency == '€') { finalPriceText = finalPriceText.replace('.', ','); }
        finalPriceField.textContent = finalPriceText;
        
        subtotalPriceRow.style.display = discountPrice == 0 ? "none" : "flex";
        discountPriceRow.style.display = discountPrice == 0 ? "none" : "flex";   

        const nonDiscountTotal = getNonDiscountTotal();
        const discountableTotal = subtotalPrice - nonDiscountTotal;
        console.log(`nonDiscountTotal = ${nonDiscountTotal}`)
        
        // calculate discount gap
        let miniCartPromotionText = "";
        let discount15Threshold = 150, discount20Threshold = 200;
        if (currency == '£') {
            discount15Threshold = discount15Threshold * 0.75;
            discount20Threshold = discount20Threshold * 0.75;
        } else if (currency == '€') {
            discount15Threshold = discount15Threshold * 0.89;
            discount20Threshold = discount20Threshold * 0.89;         
        }
        if (discountableTotal < discount15Threshold) {
            const priceGap = Math.ceil(discount15Threshold - discountableTotal);
            miniCartPromotionText = `Add ${currency}${priceGap} more to unlock 20% OFF.`;
        } else if (discountableTotal < discount20Threshold) {
            const priceGap = discount20Threshold - discountableTotal;
            miniCartPromotionText = `20% OFF unlocked! Add ${currency}${priceGap} more for %25 OFF.`;
        } else {
            miniCartPromotionText = `You've unlocked 25% OFF!`;
        }
        const miniCartPromotionBlock = document.querySelector('div.o2-mcart-discount-promotion-text');
        if (miniCartPromotionBlock != null) {
            miniCartPromotionBlock.textContent = miniCartPromotionText;
        }
    }
    const monitorOldPriceBlockChange = function() {
        const oldPriceNode = document.querySelector('div.o2-t4s-cart-price-block');
        if (oldPriceNode != null) {
            const config = {
                childList: true,      // 监听子节点的添加或删除
                subtree: true,        // 监听整个子树的节点变化
                characterData: true,  // 监听节点内容或文本变化
                attributes: false     // 是否监听属性变化，按需添加
            };
            const callback = function(mutationsList, observer) { 
                try {
                    updateNewPriceBlock(); 
                } catch (e) {
                    console.log("Failed to update new price block: " + e);
                }
            }
            const observer = new MutationObserver(callback);
            observer.observe(oldPriceNode, config);
            console.log("old price block monitor started");
            return true;
        } else {
            console.log("Failed to find old price block in mini cart");
            return false;
        }
    }
    const targetNode = document.body;
    const config = { childList: true, subtree: true };
    const callback = function(mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type == 'childList') {
                for (let node of mutation.addedNodes) {
                    if (node.nodeType == 1 && node.id == 't4s-mini_cart') {
                        console.log("mini cart is added to page");
                        updateNewPriceBlock();
                        if (monitorOldPriceBlockChange()) {
                            observer.disconnect();
                        }
                        return;
                    }
                }
            }
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
})();